import { Action, State, StateContext } from '@ngxs/store';
import * as actions from './swedish-game.actions';
import { Injectable } from '@angular/core';
import { PuzzleGameBaseState } from '../../puzzle-framework-module/puzzle-game-base.state';
import { SwedishGameStateModel } from './swedish-game-state.model';
import { patch } from '@ngxs/store/operators';

// @dynamic
@State<SwedishGameStateModel>({
  name: 'swedishGameStatesV2',
  defaults: {
    puzzleGames: {},
  },
})
@Injectable()
export class SwedishGameState extends PuzzleGameBaseState {
  @Action(actions.InitSwedishGame)
  InitSwedishGame(store: StateContext<SwedishGameStateModel>, { payload }: actions.InitSwedishGame) {
    store.setState(
      patch({
        puzzleGames: patch({ [payload.puzzleID]: payload }),
      })
    );
  }

  @Action(actions.PersistUserInput)
  PersistUserInput(store: StateContext<SwedishGameStateModel>, action: actions.PersistUserInput) {
    store.setState(
      patch({
        puzzleGames: patch({
          [action.payload.puzzleID]: patch({
            userInput: action.payload.userInput,
          }),
        }),
      })
    );
  }

  @Action(actions.SaveUserInput)
  SaveUserInput(store: StateContext<SwedishGameStateModel>, action: actions.SaveUserInput) {
    store.setState(
      patch({
        puzzleGames: patch({
          [action.payload.puzzleID]: patch({
            userInput: patch({ [action.payload.index]: action.payload.letter }),
          }),
        }),
      })
    );
  }
}
